import {
  FiltersExcludingMyAssignments,
  PatientWorkQueueItem,
} from '../PatientWorkQueue.types';
import {
  APPEAL_RETROSPECTIVE,
  FILTERS,
  MANUAL,
  PEER_TO_PEER,
  PHYSICIAN_ADVISOR,
} from '../PatientWorkQueueTable.constants';

export const filterButtonsLogicMap: Record<
  FiltersExcludingMyAssignments,
  (patient: PatientWorkQueueItem) => boolean
> = {
  [FILTERS.APPEAL_RETROSPECTIVE]: (patient) =>
    patient.escalating_review_type_desc === APPEAL_RETROSPECTIVE,
  [FILTERS.STATUS_DETERMINATION]: (patient) =>
    patient.escalating_review_type_desc !== APPEAL_RETROSPECTIVE &&
    patient.review_type_requested === PHYSICIAN_ADVISOR,
  [FILTERS.MANUAL]: (patient) => patient.review_type_requested === MANUAL,
  [FILTERS.PEER_TO_PEER]: (patient) =>
    patient.review_type_requested === PEER_TO_PEER,
};
